export default __webpack_public_path__ + "static/media/icon-cart.3769cc6b.svg";